import type { OptionProps, Option } from "components/common/utlis/TypeAnnotations";

export interface GeneralProps {
    company: Option | null;
    location: Option | null;
    pc: Option | null;
    sector: Option | null;
    domain: Option | null;
    function: Option | null;
    empType: Option | null;
    positions: string;
    formStatus: number | null;
    office: Option | null;
    consultant: Option | null;
    language: Option | null;
    aliasName: string;
    brightId: Option | null;
    pushToWebsite: number | null;
    pushToVDAB: number | null;
    pushToIndeed: number | null;
    isActive: number | null;
    contactPerson: Option | null;
}

export interface EmploymentProps {
    contract: Option | null;
    employment: Option | null;
    hrs: string;
    regime: Option | null;
    shift: Option | null;
    vdabTemplate: Option | null;
    vdabCompetences: object[];
}

export interface JobDescriptionProps {
    description: string;
    reasonForClosure: Option | null;
    info: string;
    extraInfo: string;
    fileId: number | null;
    filePath: string;
    fileName: string;
}

export interface OfferProps {
    payType: Option | null;
    starter: number | null;
    experienced: number | null;
    starterWage: string;
    experiencedWage: string;
    jobOffer: string;
}

export interface RequirementProps {
    experience: Option | null;
    driverLicence: object[];
    education: object[];
    additional: object[];
    other: string;
    equiWorkExperience: number;
    profileDescription: string;
}

export interface ErrorProps {
    company: string;
    location: string;
    function: string;
    wage: string;
    domain: string;
    office: string;
    consultant: string;
    language: string;
    pc: string;
    aliasName: string;
    fileId: string;
    vdabTemplate: string;
    vdabCompetences: string;
    driverLicence: string;
    education: string;
}

export interface TabProps {
    id: string;
    title: string;
    showStatus: boolean;
    error: boolean;
    draft: boolean;
}

export interface VacancyFormData {
    tabDetails: TabProps[];
    general: GeneralProps;
    employment: EmploymentProps;
    competences: CompetenceProps;
    jobDescription: JobDescriptionProps;
    offer: OfferProps;
    requirement: RequirementProps;
    options: OptionLists;
    errors: ErrorProps;
    currentTab: number | string;
}

export interface OptionLists {
    companyOptions: OptionProps[];
    locationOptions: OptionProps[];
    officeOptions: OptionProps[];
    languageOptions: OptionProps[];
    consultantOptions: OptionProps[];
    vdabTemplateOptions: OptionProps[];
    vdabTemplateList: OptionProps[];
    vdabCompetencesOptions: OptionProps[];
    contactPersonOptions: OptionProps[];

    experienceOptions: OptionProps[];
    driverLicOptions: OptionProps[];
    educationOptions: OptionProps[];
    additionalOptions: OptionProps[];

    sectorOptions: OptionProps[];
    pcOptions: OptionProps[];
    domainOptions: OptionProps[];
    functionOptions: OptionProps[];
    employeeTypeOptions: OptionProps[];

    contractOptions: OptionProps[];
    employmentOptions: OptionProps[];
    regimeOptions: OptionProps[];
    shiftOptions: OptionProps[];

    payTypeOptions: OptionProps[];
    functionDomainLinking: OptionProps[];
    pc: OptionProps[];

    reasonForClosureOptions: OptionProps[];
    cityOptions: OptionProps[],
    countryOptions: OptionProps[]
}

export interface CompetenceProps {
    competence: Competence[];
    candidateLevels: Options[];
    childCompetences: Record<string, ChildCompetence[]>;
}

export interface Options {
    label: string;
    value: string;
}

export interface VacancyCompetenceDetails {
    name: string;
    key: string;
    level: Option | null;
    range: number;
    competence_levels: CompetenceLevels[]
}

export interface ChildCompetence {
    name: string;
    vacancy_competence_detail: VacancyCompetenceDetails;
    [key: string]: string | VacancyCompetenceDetails;
}

export interface Competence {
    competence_name: string;
    vacancy_child_competences: ChildCompetence[];
    additional_info: string;
    competence_levels: CompetenceLevels[]
}

export interface CompetenceLevels {
    id: number;
    level: number;
    name: string;
}

//Manage vacancies page
export interface VacancyProps {
    name: string;
    type: string;
    id: number;
    brightId: number | null;
    officeName: string;
    function: string;
    hotlist_id: number | null;
    hotlisted: boolean | null;
    aliasName: string;
    vacancyStatus: number;
    updatedBy: string;
    updatedAt: string;
    webOrVDAB: string;
    officeId: string | null;
}

export interface VacancyDrpDown {
    office: OptionProps[];
    company: OptionProps[];
    function: OptionProps[];
    hotlisted: boolean | null;
    functionAliasName: string;
    isActive: Option | null;
}

export interface VacancyOverviewData {
    function: string;
    office: string;
    jobdomain: string;
    statute: string;
    employment: string;
    jobOffer: string;
    jobDesc: string;
    profileDesc: string;
    contactPerson: string;
}

export interface VacancyData {
    name: string;
    type: string;
    id: number;
    brightId: number | null;
    officeName: string;
    function: string;
    hotlist_id: number | null;
    hotlisted: boolean | null;
    aliasName: string;
    vacancyStatus: number;
    webOrVDAB: string;
    officeId: string | null;
    vacancy_status: boolean;
    unit_count: number;
    total_count: number;
    office: any;
    company: string;
    region: string;
    currentPage: number;
    recordsPerPage: number;
    userId: number | null;
    consultant: string;
    created_by: string;
    updated_by: string;
    updated_at: Date | null;
    created_at: Date | null;
    created: string;
    companyType: number | null;
    companyId: number | null;
    vdabStatus: string;
    vdabResponse: string;
    vdabLastUpdate: string;
}

export interface SearchProps {
    office: number[];
    companyName: OptionProps[];
    companyType: number | null;
    function: Option | null;
    aliasName: string;
    consultant: string;
    posting: Option | null;
    hotlist: number | null;
    leads: number | null;
    vacancyStatus: Option | null;
    vdabStatus: Option | null,
    vdabLastUpdate: Date | null | string;
    currentPage: number;
    recordsPerPage: number;
    from: Date | null | string;
    to: Date | null | string;
    orderByColumn: string;
    orderIn: "" | "asc" | "desc";
    fromDashboard: boolean;
    selectAll: boolean;
    city: number[];
}

export interface vacancyAdvSearchData {
    vdabPostStatus: Option | null;
    // city moved to the main search row (kept in SearchProps). Commented out here so
    // an empty advSearch value can't overwrite the main-row city selection on merge.
    // city: number[];
}

export const defaultVacancyAdvSearchData: vacancyAdvSearchData = {
    vdabPostStatus: null,
    // city: []
};